module.exports = __webpack_public_path__ + "static/media/sopt7ru.6a895679.pdf";